import { useMemo } from "react";
import { usePermissionStore } from "../stores/permissionStore";

interface PermissionResult {
	hasPermission: boolean;
	isLoading: boolean;
}

function usePermission(
	permission: string,
	currentProjectCode: string | null = null
): PermissionResult {
	const { hasPermission, isInitialized, checkSuperAdmin } =
		usePermissionStore();

	const result = useMemo<PermissionResult>(() => {
		// Super admin bypass
		if (checkSuperAdmin()) {
			return { hasPermission: true, isLoading: false };
		}

		// If not initialized yet, report loading
		if (!isInitialized) {
			return { hasPermission: false, isLoading: true };
		}

		const _hasPermission = hasPermission(
			permission,
			currentProjectCode || undefined
		);

		return { hasPermission: _hasPermission, isLoading: false };
	}, [
		hasPermission,
		isInitialized,
		checkSuperAdmin,
		permission,
		currentProjectCode,
	]);

	return result;
}

export default usePermission;
